import { render, staticRenderFns } from "./DateV2.vue?vue&type=template&id=4c244a1d&"
import script from "./DateV2.vue?vue&type=script&lang=js&"
export * from "./DateV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports